<ng-container *transloco="let t;">
<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">{{t("Modal header title Sign Document (Signing page - section) - Signature")}}</h4>
</div>
<div class="modal-body" tabindex="0" ngbAutofocus>
    <p class="sign-doc-infoText m-0" [innerHTML]='t("Confirm modal body text for sign document (Signing page - section) - By clicking Sign document I recipient am signing the document document and agree to be legally bound by this digital signature just the same as a pen and paper signature or by using initials", {
            recipient : recipientName,
            document : document_name
        })'></p>
</div>
<div class="modal-footer">
    <button [disabled]="signingLoader" type="button" class="btn btn-outline-secondary" (click)="modal.close(false)" rippleEffect>
        {{ t("Cancel button text (cancel button) - cancel") }}
    </button>
    <button [disabled]="signingLoader" type="button" class="btn btn-primary" rippleEffect (click)="processTheSign()">
        {{ t("Sign document button text (Signing page - section) - Sign Document") }} <span *ngIf="signingLoader" class="spinner-border spinner-border-sm me-1"></span>
    </button>
</div>
</ng-container>